import { render } from "./SSOError.vue?vue&type=template&id=0fa9bcc0"
import script from "./SSOError.vue?vue&type=script&lang=js"
export * from "./SSOError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__